import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Toaster } from './components/ui/sonner';
import Login from './pages/Login';
import StudentDashboard from './pages/StudentDashboard';
import TeacherDashboard from './pages/TeacherDashboard';
import AdminDashboard from './pages/AdminDashboard';
import MonInspectorDashboard from './pages/MonInspectorDashboard';
import LibraryPage from './pages/LibraryPage';
import BookReader from './pages/BookReader';
import VirtualClassroom from './pages/VirtualClassroom';
import PaymentResult from './pages/PaymentResult';
import PWAInstallPrompt from './components/PWAInstallPrompt';

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/library" element={<LibraryPage />} />
            <Route path="/library/read/:bookId" element={<BookReader />} />
            <Route path="/payment/success" element={<PaymentResult success={true} />} />
            <Route path="/payment/cancel" element={<PaymentResult success={false} />} />
            <Route
              path="/classroom/:lessonId"
              element={
                <ProtectedRoute>
                  <VirtualClassroom />
                </ProtectedRoute>
              }
            />
            <Route
              path="/student"
              element={
                <ProtectedRoute requiredRole="student">
                  <StudentDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/teacher"
              element={
                <ProtectedRoute requiredRole="teacher">
                  <TeacherDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute requiredRole="administrator">
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/online-admin"
              element={
                <ProtectedRoute requiredRole="online_administrator">
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/mon"
              element={
                <ProtectedRoute requiredRole="mon_inspector">
                  <MonInspectorDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
        <PWAInstallPrompt />
      </div>
    </AuthProvider>
  );
}

export default App;
